import type { SxProps, Theme } from "@mui/material";
import { Box, CircularProgress } from "@mui/material";

import { useCompressedImage } from "@/hooks/useCompressedImage";

type CompressedImageProps = {
  image: { key?: string; url: string | null | undefined } | null | undefined;
  alt?: string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  onError?: (error: Error) => void;
  showLoader?: boolean;
};

export function CompressedImage({
  image,
  alt = "",
  sx,
  onClick,
  onError,
  showLoader = false,
}: CompressedImageProps) {
  const { imageUrl, isLoading } = useCompressedImage(image);

  if (isLoading && showLoader) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...sx,
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!imageUrl) return null;

  return (
    <Box
      component="img"
      src={imageUrl}
      alt={alt}
      onClick={onClick}
      sx={sx}
      onError={() => onError?.(new Error("Failed to load image"))}
    />
  );
}
